<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px; max-width: 1200px">
    <div style="padding: 20px 30px;">
      <h3 style="text-align: center">PSQI</h3>
      <hr>
      <h4 style="text-align: center"><strong>Istruzioni: </strong>
      Le seguenti domande servono a valutare come è stato il suo sonno nell'<strong>ultimo mese.</strong>
      Per ciascuna domanda scelga la risposta che descrive meglio la maggioranza dei giorni e delle notti
      dell'ultimo mese.
      <strong>Le chiediamo, gentilmente, di rispondere a tutte le domande.</strong></h4>
    </div>
    <form [formGroup]="qForm" (ngSubmit)="onSubmit()">

      <div class="container mat-elevation-z5">

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let questionnaire">
              <ng-container *ngIf="questionnaire.position > 5 && questionnaire.position <= 15">

              </ng-container>
              <ng-container *ngIf="questionnaire.position >= 1 && questionnaire.position <= 4 || questionnaire.position === 5">
                {{questionnaire.position}}
              </ng-container>
              <ng-container *ngIf="questionnaire.position >= 16 && questionnaire.position <= 19">
                {{questionnaire.position - 10}}
              </ng-container>
            </td>
          </ng-container>


          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef> Domanda </th>
            <td mat-cell *matCellDef="let questionnaire">
              <ng-container *ngIf="questionnaire.position === 5">
                <strong> Per ciascuna delle seguenti domande (a-j), selezioni la risposta
                  più appropriata al suo caso.
                  Anche in questo caso, per favore, faccia attenzione a rispondere a tutte le domande.
                </strong>
                <br><br>
                Nell'ultimo mese, quanto spesso ha avuto problemi di sonno dovuti a...
                <br>
                {{questionnaire.question}}
              </ng-container>
              <ng-container *ngIf="questionnaire.position === 15">
                <ng-container *ngIf="this.results[questionnaire.position - 1] !== 'No' && this.results[questionnaire.position - 1] !== null; else noDisplay">
                  {{questionnaire.question}}
                </ng-container>
                <ng-template #noDisplay>
                  {{questionnaire.question}}
                </ng-template>
              </ng-container>
              <ng-container *ngIf="(questionnaire.position >= 1 && questionnaire.position <= 19 && questionnaire.position !== 5 && questionnaire.position !== 15)">
                {{questionnaire.question}}
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Valore </th>
            <td mat-cell *matCellDef="let questionnaire">
              <ng-container *ngIf="questionnaire.position >=1 && questionnaire.position <=4">
                  <ng-container *ngIf="questionnaire.position === 1">
                    <div fxLayout="row wrap">
                    <mat-form-field style="width: 80px">
                    <input matInput type="number" (change)="setResult(questionnaire.position)"
                           placeholder="Ora"
                           formControlName="{{q+questionnaire.position+'hour'}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                    </mat-form-field>
                    &nbsp;&nbsp;&nbsp;
                    <mat-form-field style="width: 80px">
                    <input style="width: 80px" matInput type="number" (change)="setResult(questionnaire.position)"
                           placeholder="Minuti"
                           formControlName="{{q+questionnaire.position+'minute'}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                    </mat-form-field>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="questionnaire.position === 2">
                    <mat-form-field>
                    <mat-label>Durata in minuti</mat-label>
                    <input style="min-width: 200px" matInput type="number" (change)="setResult(questionnaire.position)"
                           formControlName="{{q+questionnaire.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                    <mat-error *ngIf="(qForm.get('question2').hasError('min') && notFocused)">
                      Inserisci un numero
                    </mat-error>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="questionnaire.position === 3">
                    <div fxLayout="row wrap">
                      <mat-form-field style="width: 80px">
                        <input matInput type="number" (change)="setResult(questionnaire.position)"
                               placeholder="Ora"
                               formControlName="{{q+questionnaire.position+'hour'}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                      </mat-form-field>
                      &nbsp;&nbsp;&nbsp;
                      <mat-form-field style="width: 80px">
                        <input style="width: 80px" matInput type="number" (change)="setResult(questionnaire.position)"
                               placeholder="Minuti"
                               formControlName="{{q+questionnaire.position+'minute'}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                      </mat-form-field>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="questionnaire.position === 4">
                    <mat-form-field>
                    <mat-label>Numero di ore</mat-label>
                    <input matInput type="number" (change)="setResult(questionnaire.position)"
                           formControlName="{{q+questionnaire.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                    <mat-error *ngIf="(qForm.get('question4').hasError('min') && notFocused)">
                      Inserisci un numero
                    </mat-error>
                    </mat-form-field>
                  </ng-container>
              </ng-container>
              <ng-container *ngIf="questionnaire.position === 15">
                <ng-container *ngIf="this.results[questionnaire.position - 1] !== 'No' && this.results[questionnaire.position - 1] !== null; else disabled">
                  <mat-form-field>
                    <mat-label>Seleziona un valore</mat-label>
                    <mat-select required>
                      <mat-option *ngFor="let value of questionnaire.answers" [value]="value"
                                  (onSelectionChange)="selectResult($event, value, questionnaire.position + 1, questionnaire.answers)">
                        {{value}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-template #disabled>
                  <mat-form-field>
                    <mat-label>Seleziona un valore</mat-label>
                    <mat-select disabled="true">
                      <mat-option *ngFor="let value of questionnaire.answers" [value]="value"
                                  (onSelectionChange)="selectResult($event, value, questionnaire.position + 1, questionnaire.answers)">
                        {{value}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="questionnaire.position >=5 && questionnaire.position <=14">
                <mat-form-field>
                  <mat-label>Seleziona un valore</mat-label>
                  <mat-select required>
                    <mat-option *ngFor="let value of questionnaire.answers" [value]="value"
                                (onSelectionChange)="selectResult($event, value, questionnaire.position, questionnaire.answers)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-container *ngIf="questionnaire.position === 14">
                  <ng-container *ngIf="this.results[questionnaire.position - 1] !== null && this.results[questionnaire.position - 1] !== 'No'">
                    <mat-form-field>
                      <mat-label>Inserire problema</mat-label>
                      <input matInput type="text" (change)="setResult(questionnaire.position)"
                             placeholder="Problema"
                             formControlName="{{q+15}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                      <mat-error *ngIf="notFocused">
                        Inserisci il problema
                      </mat-error>
                    </mat-form-field>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="questionnaire.position >=16 && questionnaire.position <=19">
                <mat-form-field>
                  <mat-label>Seleziona un valore</mat-label>
                  <mat-select required>
                    <mat-option *ngFor="let value of questionnaire.answers" [value]="value"
                                (onSelectionChange)="selectResult($event, value, questionnaire.position + 1, questionnaire.answers)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>


      <div style="text-align: center; padding-top: 50px">
        <ng-container *ngIf="submitted">
          <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary"
                     [disabled]="!qForm.valid">Invia</button>
          </ng-container>
        </div>
      </div>

    </form>
  </div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>

